import React from 'react';
import { DatePicker } from 'antd';
import { TimePickerProps } from 'antd/lib/time-picker';

const ProTimePicker: React.FC<TimePickerProps> = React.forwardRef<
  any,
  TimePickerProps
>((props, ref) => {
  return (
    <DatePicker.TimePicker ref={ref} {...props} />
  );
});

export default ProTimePicker;
